import React from "react";
import { Navigate } from "react-router";
import { usePermissions } from "../hooks/usePermissions";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireFullAccess?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireFullAccess = true,
}) => {
  // Use a try-catch to handle the case where QueryClient is not available yet
  let hasFullAccess = true; // Default to full access to avoid blocking initial render
  
  try {
    const { hasFullAccess: userHasFullAccess } = usePermissions();
    hasFullAccess = userHasFullAccess;
  } catch (error) {
    // If QueryClient is not available, default to full access
    // This ensures the app can render and authentication can work
    console.log("QueryClient not available yet, defaulting to full access");
  }

  // If the route requires full access and user doesn't have it, redirect to dashboard
  if (requireFullAccess && !hasFullAccess) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}; 